<template>
  <header class="policyHeader">
    <div class="leftArea">
      <NuxtLink to="/" class="logo"></NuxtLink>
      <ul class="path">
        <li>Policy</li>
      </ul>
    </div>
    <div class="langSelect" @click.stop="openLangToggle = !openLangToggle">
      <div class="downToggle" :class="{ on: openLangToggle }">
        <div class="icon"></div>
      </div>
      <ul class="scrollY" :class="{ on: openLangToggle }">
        <li v-for="(lang, index) of keysOfLanguages" :key="index" :class="{ active: $i18n.locale.value === lang }" @click.stop="changeLocale(lang)">
          {{ LocalLanguagesType[lang] }}
        </li>
      </ul>
    </div>
  </header>
</template>

<script setup lang="ts">
import LocalLanguagesType from '~~/package/enum/LocalLanguagesType';
import {useUserService} from '~~/application/composables/service/useUserService';

const openLangToggle = ref(false);

const { t } = useI18n();
const { $i18n } = useNuxtApp();

const keysOfLanguages = computed((): Array<string> => {
  return Object.keys(LocalLanguagesType);
});

const changeLocale = (locale: string) => {
  useUserService().setUserLocale(locale);
  window.scrollTo(0, 0);
  $i18n.setLocale(locale);
  openLangToggle.value = false;
}
</script>